/* input.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName", "testId"];
import "./input.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@compiled/react';
import { cleanCommonProps, getStyleProps } from '../../utils';
export var inputCSS = function inputCSS() {
  return {};
};
var inputStyles = {
  root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
  disabled: "_3um015vq"
};
var nativeInnputStyles = null;
var hidden = null;
var Input = function Input(props) {
  var builtinCX = props.cx,
    value = props.value,
    xcss = props.xcss;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    testId = _cleanCommonProps.testId,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded);
  var dataId = testId ? "".concat(testId, "-select--input") : null;
  var _getStyleProps = getStyleProps(props, 'input', {
      'input-container': true
    }),
    css = _getStyleProps.css,
    className = _getStyleProps.className;
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    style: css
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    ,
    className: ax([inputStyles.root, isDisabled && inputStyles.disabled, cx(className, xcss, '-Input')]),
    "data-value": value || '',
    "data-testid": dataId && "".concat(dataId, "-container")
  }, /*#__PURE__*/React.createElement("input", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n", isHidden && "_tzy4idpf", builtinCX({
      input: true
    }, inputClassName, '-input')]),
    ref: innerRef,
    disabled: isDisabled,
    "data-testid": dataId
  }, innerProps)));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Input;